module.exports = __webpack_public_path__ + "static/media/20ECE16.84d77bdd.jpg";